import { PicoApp } from "./PicoApp.ts";
import { PicoAppEnum } from "./PicoAppEnum.ts";

export const PICO_APPS: PicoApp[] = [
  {
    id: PicoAppEnum.PICO_COM,
    name: "pičo.com",
    description: "Centrální portál",
    requiredRole: "user",
    feUrlEnvKey: "VITE_PICO_COM_FE_URL",
    showInLauncher: false,
    hasRequestQueue: true,
  },
  {
    id: PicoAppEnum.CHLAST_PICO,
    name: "Chlast PIČO",
    description: "Sledování pití",
    requiredRole: "user",
    feUrlEnvKey: "VITE_CHLAST_PICO_FE_URL",
    showInLauncher: true,
    hasRequestQueue: true,
  },
  {
    id: PicoAppEnum.KUKANA_PICO,
    name: "Kukaňa PIČO",
    description: "Admin panel",
    requiredRole: "admin",
    feUrlEnvKey: "VITE_KUKANA_PICO_FE_URL",
    showInLauncher: false,
    hasRequestQueue: false,
  },
  {
    id: PicoAppEnum.SIPKY_PICO,
    name: "Šipky PIČO",
    description: "Sledování šipek",
    requiredRole: "user",
    feUrlEnvKey: "VITE_SIPKY_PICO_FE_URL",
    showInLauncher: false,
    hasRequestQueue: true,
  },
  {
    id: PicoAppEnum.BEERRALLY_PICO,
    name: "Beer Rally PIČO",
    description: "Kalendář pivních závodů",
    requiredRole: "user",
    feUrlEnvKey: "VITE_BEERRALLY_PICO_FE_URL",
    showInLauncher: true,
    hasRequestQueue: true,
  },
  {
    id: PicoAppEnum.KDESU_PICO,
    name: "Kdesu PIČO",
    description: "Mapa hospod",
    requiredRole: "public",
    feUrlEnvKey: "VITE_KDESU_PICO_FE_URL",
    showInLauncher: true,
    hasRequestQueue: false,
  },
  {
    id: PicoAppEnum.SKLADKA_PICO,
    name: "Skládka PIČO",
    description: "Úložiště souborů",
    requiredRole: "user",
    feUrlEnvKey: "VITE_SKLADKA_PICO_FE_URL",
    showInLauncher: true,
    hasRequestQueue: false,
  },
];
